import { SuperTableRowType } from '@modeso/types__aumico-lib-annualreport-be';

export interface ISuperTableItemSelection {
    name: string;
    caption: string;
    currentValue: number;
    previousValue: number;
    type: SuperTableRowType;
    [key: string]: string | number; //for extra columns
}
